module.exports = "/_next/static/images/CollectionCloudSources-f46af73f9659f1bcc30cfa752d4671a7.webp";